// 一次连接的最大时间
import BaseEvent from "../../util/baseEvent"
import { DISCOVER, ERRORLIST, ITC, TIMEROUT } from "../../util/eventTypes"
// 从开始选点ping 到连接ws 到发送200，201消息成功之后总共耗时30s,超过这个时间就关闭连接
const MAX_CONNECT_TIME = TIMEROUT.MAX_CONNECT_TIME
class ConnectOverTimeMange extends BaseEvent {
  constructor() {
    super()
    this.connectTimeoutHandle = null
    this.starTime = new Date().getTime()
    this.endTime = new Date().getTime()
    this.initEvent()
  }
  initEvent() {
    // 开始 一次连接
    this.eventEmitter.on(ITC.START_CONNECT, () => {
      // 设置定时器
      // 如果已经设置了定时器 不在设置新的定时器
      if (this.connectTimeoutHandle) {
        return
      }
      this.connectTimeoutHandle = setTimeout(() => {
        this.eventEmitter.emit(ITC.CLOSE, ERRORLIST.CONNECT_OVER_MAXTIME_LIMIT)
      }, MAX_CONNECT_TIME)
      this.starTime = new Date().getTime()
    })
    // 完成一次连接
    this.eventEmitter.on(ITC.CONNECTED, (res, ws) => {
      // 清除定时器
      this.connectTimeoutHandle && clearTimeout(this.connectTimeoutHandle)
      this.connectTimeoutHandle = null
      this.endTime = new Date().getTime()
      let range = this.endTime - this.starTime
      // this.eventEmitter.emit(LOG.INFO, DISCOVER.CONNECT_CONSUME_TIME, {
      //   range,
      //   ws
      // })
      this.$logger.info(DISCOVER.CONNECT_CONSUME_TIME, {
        range,
        ws
      })
    })
  }
  destroy() {
    this.eventEmitter.removeAllListeners(ITC.START_CONNECT)
    this.eventEmitter.removeAllListeners(ITC.CONNECTED)
    this.connectTimeoutHandle && clearTimeout(this.connectTimeoutHandle)
  }
}
export default ConnectOverTimeMange
// # sourceMappingURL=connectOvertimeManage.js.map
